<div class="modal-header" [ngClass]="{ 'alert-info': alertMessage }">
    @if (alertMessage) {
        <h4 class="modal-title pull-left">{{ alertMessage }}</h4>
    } @else {
        <h4 class="modal-title pull-left" translate>Update tags</h4>
    }

    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    @if (!tags.length) {
        <div>
            @if (isAdmin) {
                <p>
                    {{ "You don't have any tags yet. Add some tags" | translate }}
                    <a [href]="environment.settingsUrl + communityName + '/community/tags'" translate>here</a>
                </p>
            } @else {
                <p translate>You don't have any tags yet. Talk to your administrator to get access to add some.</p>
            }
        </div>
    }

    <label class="label-as-container">
        @if (tags.length) {
            <span class="label-value">
                @if (isReply) {
                    <span translate>Select tags for the reply</span>
                } @else {
                    <span translate>Select tags for the ticket</span>
                }
            </span>
        }
        <app-tags-input
            [autofocus]="true"
            [selectedItems]="newTags"
            [focusTimeout]="500"
            [items]="tags"
            [isTagCreationEnabled]="isTagCreationEnabled"
            [isInvalid]="isSubmitted && !newTags.length"
            displayBy="text">
        </app-tags-input>
    </label>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" translate>Save</button>
</div>
